/* global google */
import React, { useState, useEffect, useMemo } from 'react';
import { GoogleMap, InfoWindow, Marker } from '@react-google-maps/api';
import { mapStyle } from '../../utils/mapConstants';

const FacilityMap = ({ facilities }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [infoWindowData, setInfoWindowData] = useState();
    const [mapRef, setMapRef] = useState();

    const { mapMarkers, mapBounds } = useMemo(() => {
        const markers = [];
        const bounds = new google.maps.LatLngBounds();
        facilities.forEach(facility => {
            if (facility.location && facility.location.lat && facility.location.lng) {
                markers.push({
                    lat: facility.location.lat,
                    lng: facility.location.lng,
                    facilityId: facility.facility_id,
                    retailerFacilityId: facility.retailer_facility_id,
                    address: facility.address || 'Address not available',
                });
                bounds.extend({
                    lat: facility.location.lat,
                    lng: facility.location.lng,
                });
            }
        });
        return { mapMarkers: markers, mapBounds: bounds };
    }, [facilities]);

    useEffect(() => {
        if (mapRef) {
            if (mapBounds.isEmpty()) {
                // Default center if no facilities with locations
                mapRef.setCenter({ lat: 60, lng: 18 });
                mapRef.setZoom(4);
            } else {
                mapRef.fitBounds(mapBounds);
            }
        }
    }, [facilities, mapRef, mapBounds]);

    const handleMapLoad = map => {
        setMapRef(map);
    };

    const handleMarkerClick = (facilityId, retailerFacilityId, address) => {
        setInfoWindowData({
            facilityId,
            retailerFacilityId,
            address,
        });
        setIsOpen(true);
    };

    const handleMapClick = () => {
        setIsOpen(false);
    };

    return (
        <div className="card-wrapper customer-details__map">
            <div className="customer-details__card-header">Locations</div>
            <div className="card-body">
                <GoogleMap
                    onLoad={handleMapLoad}
                    mapContainerStyle={{
                        width: '100%',
                        minHeight: '400px',
                    }}
                    options={{
                        styles: mapStyle,
                    }}
                    onClick={handleMapClick}
                    zoom={4}
                >
                    {mapMarkers.map(marker => (
                        <Marker
                            key={marker.facilityId}
                            position={{
                                lat: marker.lat,
                                lng: marker.lng,
                            }}
                            icon="/assets/icons/map-marker.svg"
                            onClick={() => {
                                handleMarkerClick(marker.facilityId, marker.retailerFacilityId, marker.address);
                            }}
                            animation={google.maps.Animation.DROP}
                        >
                            {isOpen && infoWindowData?.facilityId === marker.facilityId && (
                                <InfoWindow
                                    options={{
                                        maxWidth: 250,
                                    }}
                                >
                                    <div id="content">
                                        <div id="bodyContent" style={{ margin: '3px 0' }}>
                                            <p
                                                style={{
                                                    marginLeft: '8px',
                                                    fontSize: '12px',
                                                    color: '#666',
                                                }}
                                            >
                                                {marker.address}
                                            </p>
                                        </div>
                                    </div>
                                </InfoWindow>
                            )}
                        </Marker>
                    ))}
                </GoogleMap>
            </div>
        </div>
    );
};

export default FacilityMap;
